import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { StorageService } from './../../../../../core/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WebsiteFooterComponent implements OnInit {

  menuNames: any = [];
  userInfo:any={};
  userInfoSubscription: Subscription;
  openChat: boolean;
  loggedIn: boolean = false;
  copyRightYear = new Date().getFullYear();
  clientDetails: any;
  assets_url = environment.assets_url;
  constructor(public router: Router,private commanSubscribeService: CommanSubscribeService,private storageService: StorageService,public route: ActivatedRoute) { }

  
  ngOnInit() {
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.clientDetails = environment.clientDetails;
    let userInfo = this.storageService.getItem('user_Info');
      if (userInfo && userInfo.access_token && this.userInfo && this.userInfo.id) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    // this.menuNames = ['home', 'creators', 'organizers', 'fans', 'browse'];
    this.menuNames = ['Home', 'Creators', 'Fans'];
  }

  goToRespectiveScreen(path) {
    if (path == 'home')
      this.router.navigateByUrl('');
    else
      this.router.navigateByUrl(path);
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Footer ${path} - clicked - ${userId}`)
      const data = {
        actionType: "event",
        metaData: {
          title: `Footer ${path} - clicked`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,

      }
      this.commanSubscribeService.sendTriggeredEvent(data);
  }
  ContactUs(){
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Footer Contact Us - clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "Footer Contact Us - clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
  }
  facebookLogo(){
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Footer Follow Us - clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "Footer Follow Us - clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
  }
  openKoopid(){
    this.openChat = !this.openChat;
  }

  redirectTo() {
    this.router.navigateByUrl('/');
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }

}
